(function () {
    /**
     * Variable used to cache user browser data
     * @type {null|Bowser.Parser.Parser}
     */
    let browser = null
    /**
     * Returns the user agent data
     * @return {Bowser.Parser.Parser}
     */
    let getBrowser = function () {
        if (browser === null) {
            browser = bowser.getParser(window.navigator.userAgent);
        }
        return browser;
    }
    /**
     * Os lies on safari ipad that it is macOS, so use an additional touch support check to detect whether its macos or not
     * @return {boolean}
     */
    PMW.isMacOS = function () {
        return getBrowser().is('macOS') && !PMW.isTouchSupported();
    }
    /**
     * @return {boolean}
     */
    PMW.isAndroidOS = function () {
        return getBrowser().is('Android');
    }
    /**
     * @return {boolean}
     */
    PMW.isEdge = function () {
        return getBrowser().isBrowser('Microsoft Edge');
    }
    /**
     * Whether we're currently on iOS or Android.
     * @type {boolean}
     */
    PMW.isMobileOS = function () {
        return PMW.isIOS() || PMW.isAndroidOS();
    }
    /**
     * @return {boolean}
     */
    PMW.isIOS = function () {
        return PMW.isIphone() || PMW.isIpad();
    }
    /**
     * @return {boolean}
     */
    PMW.isIOSApp = function () {
        return navigator.userAgent.includes('iosPwaApp');
    }
    /**
     * Os lies on safari ipad that it is macOS, so use an additional touch support check to detect whether its ios or not
     * @return {boolean}
     */
    PMW.isIpad = function () {
        return getBrowser().is('macOS') && PMW.isTouchSupported();
    }

    /**
     * Returns false for iPad as it sends MacOS rather than iOS
     * @return {boolean}
     */
    PMW.isIphone = function () {
        return getBrowser().is('iOS');
    }
    /**
     *
     * @return {string}
     */
    PMW.getBrowserVersion = function () {
        return getBrowser().getBrowserVersion();
    }
    /**
     * @return {string}
     */
    PMW.getBrowserName = function () {
        return getBrowser().getBrowserName();
    }
    /**
     * @return {boolean}
     */
    PMW.isIOSSafari = function () {
        return PMW.isSafari() && PMW.isIOS()
    }
    /**
     * @return {boolean}
     */
    PMW.isMacOSSafari = function () {
        return PMW.isSafari() && PMW.isMacOS()
    }
    /**
     * @return {boolean}
     */
    PMW.isSafari = function () {
        return getBrowser().isBrowser('Safari');
    }
    /**
     * @return {boolean}
     */
    PMW.isFirefox = function () {
        return getBrowser().isBrowser('Firefox');
    }
    /**
     * @return {boolean}
     */
    PMW.isIE = function () {
        return getBrowser().isBrowser('Internet Explorer');
    }
    /**
     * @return {boolean}
     */
    PMW.isChrome = function () {
        return getBrowser().isBrowser('Chrome');
    }
    /**
     * @return {boolean}
     */
    PMW.isTouchSupported = function () {
        return !!Modernizr.touchevents;
    }
    /**
     * Variable to cache whether browser supports webm or not so that it is not determined each time
     * @type {boolean|null}
     * @private
     */
    let doesBrowserSupportWebmCache_ = null;
    /**
     * Returns true if the browser supports webm, false otherwise
     * @returns {boolean}
     */
    PMW.doesBrowserSupportWebm = function () {
        if(PMW.isSafari()){
            return false;
        }
        if (doesBrowserSupportWebmCache_ === null) {
            let video = document.createElement('video');
            doesBrowserSupportWebmCache_ = video.canPlayType('video/webm; codecs="vp8, vorbis"') === "probably";
        }
        return doesBrowserSupportWebmCache_;
    }
})();
